import { white } from 'styles'

import { makeStyles } from '@mui/styles'

export default makeStyles({
  hidden: {
    display: 'none',
  },
  loader: {
    zIndex: 20,
  },
  loaderWrapper: {
    alignItems: 'center',
    bottom: '0',
    justifyContent: 'center',
    left: '0',
    position: 'absolute',
    right: '0',
    top: '0',
    zIndex: 15,
  },
  overlay: {
    bottom: '0',
    left: '0',
    opacity: 0.7,
    position: 'absolute',
    right: '0',
    top: '0',
    zIndex: 10,
    backgroundColor: white,
  },
  root: {
    position: 'relative',
  },
})
